export const PENDING_ORDER_STORAGE_KEY = 'choripan_pending_order_submission';

export type PendingOrderSubmission = {
  version: 1;
  idempotencyKey: string;
  request: {
    items: Array<{ product: string; quantity: number; selectedOptions?: Record<string, string> }>;
    paymentMethod: string;
    delivery?: Record<string, any>;
    couponCode?: string;
    idempotencyKey: string;
  };
  cartSnapshot: any[];
  deliverySnapshot: Record<string, any>;
  couponSnapshot?: { code: string; discount: number; description: string } | null;
  savedAt: string;
};

export const savePendingOrderSubmission = (
  submission: Omit<PendingOrderSubmission, 'version' | 'savedAt'>,
  storage: Storage = window.localStorage,
) => {
  const record: PendingOrderSubmission = {
    ...submission,
    version: 1,
    savedAt: new Date().toISOString(),
  };
  const serialized = JSON.stringify(record);
  storage.setItem(PENDING_ORDER_STORAGE_KEY, serialized);
  return JSON.parse(serialized) as PendingOrderSubmission;
};

export const loadPendingOrderSubmission = (storage: Storage = window.localStorage): PendingOrderSubmission | null => {
  const raw = storage.getItem(PENDING_ORDER_STORAGE_KEY);
  if (!raw) return null;
  const parsed = JSON.parse(raw);
  if (
    !parsed || parsed.version !== 1 || typeof parsed.idempotencyKey !== 'string' ||
    parsed.request?.idempotencyKey !== parsed.idempotencyKey ||
    !Array.isArray(parsed.request?.items) || !Array.isArray(parsed.cartSnapshot) ||
    !parsed.deliverySnapshot || typeof parsed.deliverySnapshot !== 'object' ||
    typeof parsed.savedAt !== 'string'
  ) {
    throw new Error('La solicitud pendiente está dañada y no se puede reintentar con seguridad.');
  }
  return parsed as PendingOrderSubmission;
};

export const clearPendingOrderSubmission = (storage: Storage = window.localStorage) =>
  storage.removeItem(PENDING_ORDER_STORAGE_KEY);
